var map = {
	"./57_legs.mp3": "ecaa",
	"./58_hands.mp3": "6c09",
	"./59_head.mp3": "11f9",
	"./60_tummy.mp3": "0abe",
	"./61_stretch.mp3": "017d",
	"./62_shake.mp3": "3c49",
	"./63_pat.mp3": "eaf8",
	"./64_hat.mp3": "9826",
	"./65_T-shirt.mp3": "7ebdd",
	"./66_dress.mp3": "323c",
	"./67_jumper.mp3": "7c79",
	"./68_jacket.mp3": "41ee",
	"./69_shoes.mp3": "db71",
	"./70_jeans.mp3": "04bc",
	"./766_4_be_quiet.mp3": "ac17",
	"./766_4_group_rules.mp3": "ae9d",
	"./766_4_listen.mp3": "10b5",
	"./766_4_look.mp3": "b555",
	"./766_4_sit_down.mp3": "d7cc",
	"./766_4_stand_up.mp3": "4f51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ebe";